/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const saveManualDocument = async (data) => {
  try {
    const params = new URLSearchParams({
      type: data?.type,
      folderId: data?.folderId,
    }).toString();
    return await apiClient.post(`${apiEndpoint}${API.MANUAL_DOCUMENTS.SAVE_DOCUMENT}?${params}`, data?.formData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDocumentList = async (data) => {
  try {
    console.log('data..........', data);
    return await apiClient.post(`${apiEndpoint}${API.MANUAL_DOCUMENTS.GET_DOCUMENT_LIST}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const MultiDeleteManualDocument = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.MANUAL_DOCUMENTS.DELETE_DOCUMENT}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBreadCrumbData = async (folderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.MANUAL_DOCUMENTS.BREAD_CRUMB_DATA}?folderId=${folderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const archiveUnarchiveDocument = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MANUAL_DOCUMENTS.ARCHIEVE_UNARCHIEVE_DATA}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getDocumentDataById = async (folderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.MANUAL_DOCUMENTS.GET_FILE_BY_ID}/${folderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const renewManualDocument = async (data) => {
  try {
    const params = new URLSearchParams({
      type: 'file',
      folderId: data?.folderId,
    }).toString();
    return await apiClient.post(`${apiEndpoint}${API.MANUAL_DOCUMENTS.RENEW_DOCUMENT}/${data?._id}?${params}`, data?.formData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllFolderList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.MANUAL_DOCUMENTS.GET_ALL_FOLDER_DOCUMENT}?folderId=${data?.id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const moveDocumentToFolder = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MANUAL_DOCUMENTS.MOVE_DOCUMENT}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const shareDocumentWithSupplier = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.MANUAL_DOCUMENTS.SHARE_DOCUMENT}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateManualDocument = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.MANUAL_DOCUMENTS.EDIT_DOCUMENT}/${data?._id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// export const downloadFolder = async (id) => {
//   try {
//     // const response = await fetch(`${apiEndpoint}${API.MANUAL_DOCUMENTS.DOWNLOAD_FOLDER}/${id}`); // Ensure the URL and params are correct
//     // Make the API call with responseType as 'arraybuffer'
//     const response = await apiClient.get(`${apiEndpoint}${API.MANUAL_DOCUMENTS.DOWNLOAD_FOLDER}/${id}`, {
//       responseType: "arraybuffer", // Important for binary data
//     });

//     // Convert the ArrayBuffer to a Blob
//     const blob = new Blob([response.data], { type: "application/zip" });
//     // // Read the response as an ArrayBuffer (binary data)
//     // const buffer = await response.arrayBuffer();
//     // console.log("bufferbuffer", buffer);
//     // // Convert ArrayBuffer to a Blob
//     // const blob = new Blob([buffer], { type: "application/zip" });
//     console.log("blobblob", blob);
//     return blob;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

export const downloadFolder = async (id) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
      };
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiEndpoint}${API.MANUAL_DOCUMENTS.DOWNLOAD_FOLDER}/${id}`, {
            ...config,
            withCredentials: true,
          })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/zip',
            });
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};
